module.exports = __webpack_public_path__ + "37977b95dcdacf749d98f56fe108bfa6.MP3";